import { User } from "../../dto/user"
import httpClient from "../../service/api"

export const save = async (user:User) : Promise<void> => {
  await httpClient.post('/api/user/password/update', {'id' : user.id, 'password' : user.password})
}

